module.exports = __webpack_public_path__ + "static/media/8OLA19.98d477f7.jpg";